












import { Vue, Component, Watch } from "vue-property-decorator";
import HtmlPage from "../../share/html-page/HtmlPage.vue";
import { detectMob } from "../../common/mobileHelper";
import AnalyticsMixin from "../../mixins/AnalyticsMixin";

@Component({
    name: 'InfoView',
    components: { HtmlPage }
})
export default class InfoView extends AnalyticsMixin {
    schemaId: string | null = null;
    openChat = false;
    wide = false;

    async mounted() {
        this.reInit();

        if (!detectMob() && this.openChat && this.$store.state.services.freshChat) {
            setTimeout(() => {
                this.$store.state.services.freshChat.open();
            }, 200);
        }
    }

    @Watch("objectId")
    reInit() {
        const infoParams = this.$store.getters['events/selectedEventViewParam']('info', null);
        const objectId = this.objectId;

        if (infoParams) {
            if(Array.isArray(infoParams)) {
                const infoParamsItem = infoParams.find((item) => item.objectId === objectId);
                if(infoParamsItem && infoParamsItem.schemaId) {
                    this.setParams(infoParamsItem);
                }
            }
            else if(typeof infoParams === "object" && infoParams.schemaId) {
                this.setParams(infoParams);
            }
        }

        this.sendScreenView('FAQ', this.objectId, this.schemaId);
    }

    setParams(infoParams: any) {
        this.schemaId = infoParams.schemaId;
        this.openChat = infoParams.openChat ?? false;
        this.wide = infoParams?.wide === true;

        this.$store.dispatch("setPageTitle", infoParams?.title);
    }

    get objectId(): string | null {
        return this.$route.params.objectId;
    }

    beforeDestroy() {
        if (!detectMob() && this.openChat && this.$store.state.services.freshChat) {
            this.$store.state.services.freshChat.close();
        }
    }
}
